import { Launch } from '@mui/icons-material'
import { Card, CardContent, CardHeader, IconButton } from '@mui/material'
import dayjs from 'dayjs'
import RouterLink from '../../RouterLink'

export function RichListCardLayout(props: { content: React.ReactNode }) {
  return (
    <Card>
      <CardHeader
        title="Rich list"
        subheader={dayjs().subtract(1, 'day').format('L')}
        action={
          <IconButton component={RouterLink} to={`richlist`}>
            <Launch />
          </IconButton>
        }
      />
      <CardContent>{props.content}</CardContent>
    </Card>
  )
}
